import { DrawerSizeOptions } from 'common-controls/Drawer/DrawerSizeOptions'

export const DrawerSizes = (state) => {
  return DrawerSizeOptions
}

export const DrawerList = (state) => {
  return state.Drawer.drawers || []
}
